"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  "akaa": {
    "lat": 61.167408,
    "lng": 23.867642
  },
  "alajärvi": {
    "lat": 63.00285,
    "lng": 23.803185
  },
  "alavieska": {
    "lat": 64.158003,
    "lng": 24.299759
  },
  "alavus": {
    "lat": 62.586607,
    "lng": 23.617282
  },
  "asikkala": {
    "lat": 61.172331,
    "lng": 25.538409
  },
  "askola": {
    "lat": 60.526205,
    "lng": 25.591785
  },
  "aura": {
    "lat": 60.655292,
    "lng": 22.593584
  },
  "brändö": {
    "lat": 60.41338,
    "lng": 21.044081
  },
  "eckerö": {
    "lat": 60.21344,
    "lng": 19.626181
  },
  "enonkoski": {
    "lat": 62.091052,
    "lng": 28.922629
  },
  "enontekiö": {
    "lat": 68.385909,
    "lng": 23.60561
  },
  "espoo": {
    "lat": 60.20678,
    "lng": 24.65578
  },
  "eura": {
    "lat": 61.131415,
    "lng": 22.14648
  },
  "eurajoki": {
    "lat": 61.203184,
    "lng": 21.738904
  },
  "evijärvi": {
    "lat": 63.362182,
    "lng": 23.459548
  },
  "finström": {
    "lat": 60.229252,
    "lng": 19.98921
  },
  "forssa": {
    "lat": 60.824104,
    "lng": 23.587275
  },
  "föglö": {
    "lat": 60.03001,
    "lng": 20.38789
  },
  "geta": {
    "lat": 60.375191,
    "lng": 19.848301
  },
  "haapajärvi": {
    "lat": 63.745705,
    "lng": 25.335395
  },
  "haapavesi": {
    "lat": 64.1409,
    "lng": 25.367871
  },
  "hailuoto": {
    "lat": 65.0132,
    "lng": 24.728905
  },
  "halsua": {
    "lat": 63.465301,
    "lng": 24.165394
  },
  "hamina": {
    "lat": 60.570992,
    "lng": 27.189425
  },
  "hammarland": {
    "lat": 60.216461,
    "lng": 19.73711
  },
  "hankasalmi": {
    "lat": 62.396007,
    "lng": 26.43071
  },
  "hanko": {
    "lat": 59.82332,
    "lng": 22.96822
  },
  "harjavalta": {
    "lat": 61.31049,
    "lng": 22.11737
  },
  "hartola": {
    "lat": 61.58064,
    "lng": 26.00777
  },
  "hattula": {
    "lat": 61.05386,
    "lng": 24.37172
  },
  "hausjärvi": {
    "lat": 60.7889,
    "lng": 25.020735
  },
  "heinola": {
    "lat": 61.202291,
    "lng": 26.036436
  },
  "heinävesi": {
    "lat": 62.423315,
    "lng": 28.624105
  },
  "helsinki": {
    "lat": 60.17116,
    "lng": 24.93258
  },
  "hirvensalmi": {
    "lat": 61.646105,
    "lng": 26.772059
  },
  "hollola": {
    "lat": 60.985714,
    "lng": 25.537673
  },
  "honkajoki": {
    "lat": 62.00408,
    "lng": 22.232362
  },
  "huittinen": {
    "lat": 61.188817,
    "lng": 22.688858
  },
  "humppila": {
    "lat": 60.933793,
    "lng": 23.36465
  },
  "hyrynsalmi": {
    "lat": 64.67933,
    "lng": 28.48336
  },
  "hyvinkää": {
    "lat": 60.629295,
    "lng": 24.8574
  },
  "hämeenkoski": {
    "lat": 61.021995,
    "lng": 25.15348
  },
  "hämeenkyrö": {
    "lat": 61.653732,
    "lng": 23.175646
  },
  "hämeenlinna": {
    "lat": 60.996895,
    "lng": 24.466265
  },
  "ii": {
    "lat": 65.322485,
    "lng": 25.377725
  },
  "iisalmi": {
    "lat": 63.55664,
    "lng": 27.19146
  },
  "iitti": {
    "lat": 60.8942,
    "lng": 26.33842
  },
  "ikaalinen": {
    "lat": 61.761652,
    "lng": 23.069712
  },
  "ilmajoki": {
    "lat": 62.72764,
    "lng": 22.58856
  },
  "ilomantsi": {
    "lat": 62.666899,
    "lng": 30.937516
  },
  "imatra": {
    "lat": 61.213404,
    "lng": 28.825477
  },
  "inari": {
    "lat": 68.906185,
    "lng": 27.027515
  },
  "inkoo": {
    "lat": 60.04602,
    "lng": 24.005355
  },
  "isojoki": {
    "lat": 62.114536,
    "lng": 21.957375
  },
  "isokyrö": {
    "lat": 62.998262,
    "lng": 22.320665
  },
  "jalasjärvi": {
    "lat": 62.491804,
    "lng": 22.745358
  },
  "janakkala": {
    "lat": 60.920625,
    "lng": 24.649785
  },
  "joensuu": {
    "lat": 62.604225,
    "lng": 29.759265
  },
  "jokioinen": {
    "lat": 60.791253,
    "lng": 23.498402
  },
  "jomala": {
    "lat": 60.15871,
    "lng": 19.943541
  },
  "joroinen": {
    "lat": 62.182461,
    "lng": 27.820605
  },
  "joutsa": {
    "lat": 61.742449,
    "lng": 26.115608
  },
  "juankoski": {
    "lat": 63.06517,
    "lng": 28.32945
  },
  "juuka": {
    "lat": 63.24358,
    "lng": 29.255269
  },
  "juupajoki": {
    "lat": 61.797221,
    "lng": 24.435872
  },
  "juva": {
    "lat": 61.894588,
    "lng": 27.866609
  },
  "jyväskylä": {
    "lat": 62.24049,
    "lng": 25.751295
  },
  "jämijärvi": {
    "lat": 61.822029,
    "lng": 22.686075
  },
  "jämsä": {
    "lat": 61.865018,
    "lng": 25.176749
  },
  "järvenpää": {
    "lat": 60.471294,
    "lng": 25.089955
  },
  "kaarina": {
    "lat": 60.41014,
    "lng": 22.384209
  },
  "kaavi": {
    "lat": 62.97441,
    "lng": 28.486644
  },
  "kajaani": {
    "lat": 64.225305,
    "lng": 27.729545
  },
  "kalajoki": {
    "lat": 64.259436,
    "lng": 23.944601
  },
  "kangasala": {
    "lat": 61.463485,
    "lng": 24.0735
  },
  "kangasniemi": {
    "lat": 62.005273,
    "lng": 26.647527
  },
  "kankaanpää": {
    "lat": 61.80307,
    "lng": 22.39508
  },
  "kannonkoski": {
    "lat": 62.97855,
    "lng": 25.2664
  },
  "kannus": {
    "lat": 63.903475,
    "lng": 23.923265
  },
  "karijoki": {
    "lat": 62.305767,
    "lng": 21.699507
  },
  "karkkila": {
    "lat": 60.534325,
    "lng": 24.226075
  },
  "karstula": {
    "lat": 62.881293,
    "lng": 24.799977
  },
  "karvia": {
    "lat": 62.14048,
    "lng": 22.56376
  },
  "kaskinen": {
    "lat": 62.380215,
    "lng": 21.238619
  },
  "kauhajoki": {
    "lat": 62.454823,
    "lng": 22.213747
  },
  "kauhava": {
    "lat": 63.105971,
    "lng": 23.057789
  },
  "kauniainen": {
    "lat": 60.211642,
    "lng": 24.729048
  },
  "kaustinen": {
    "lat": 63.547708,
    "lng": 23.693802
  },
  "keitele": {
    "lat": 63.178253,
    "lng": 26.341063
  },
  "kemi": {
    "lat": 65.736605,
    "lng": 24.567065
  },
  "kemijärvi": {
    "lat": 66.718941,
    "lng": 27.389046
  },
  "keminmaa": {
    "lat": 65.795675,
    "lng": 24.52772
  },
  "kemiönsaari": {
    "lat": 60.16945,
    "lng": 22.73735
  },
  "kempele": {
    "lat": 64.912102,
    "lng": 25.507429
  },
  "kerava": {
    "lat": 60.401685,
    "lng": 25.128357
  },
  "keuruu": {
    "lat": 62.259475,
    "lng": 24.696065
  },
  "kihniö": {
    "lat": 62.198965,
    "lng": 23.189565
  },
  "kinnula": {
    "lat": 63.368945,
    "lng": 24.974996
  },
  "kirkkonummi": {
    "lat": 60.12315,
    "lng": 24.441655
  },
  "kitee": {
    "lat": 62.103875,
    "lng": 30.135511
  },
  "kittilä": {
    "lat": 67.65684,
    "lng": 24.9084
  },
  "kiuruvesi": {
    "lat": 63.65175,
    "lng": 26.61161
  },
  "kivijärvi": {
    "lat": 63.119735,
    "lng": 25.081655
  },
  "kokemäki": {
    "lat": 61.255985,
    "lng": 22.346685
  },
  "kokkola": {
    "lat": 63.838455,
    "lng": 23.13003
  },
  "kolari": {
    "lat": 67.33146,
    "lng": 23.7829
  },
  "konnevesi": {
    "lat": 62.621835,
    "lng": 26.267955
  },
  "kontiolahti": {
    "lat": 62.76317,
    "lng": 29.847251
  },
  "korsnäs": {
    "lat": 62.78509,
    "lng": 21.18869
  },
  "koski tl": {
    "lat": 60.65668,
    "lng": 23.135345
  },
  "kotka": {
    "lat": 60.46631,
    "lng": 26.946485
  },
  "kouvola": {
    "lat": 60.871255,
    "lng": 26.703185
  },
  "kristiinankaupunki": {
    "lat": 62.271923,
    "lng": 21.394115
  },
  "kruunupyy": {
    "lat": 63.731035,
    "lng": 23.03892
  },
  "kuhmo": {
    "lat": 64.121605,
    "lng": 29.50632
  },
  "kuhmoinen": {
    "lat": 61.564801,
    "lng": 25.178958
  },
  "kumlinge": {
    "lat": 60.314054,
    "lng": 20.704044
  },
  "kuopio": {
    "lat": 62.89313,
    "lng": 27.676125
  },
  "kuortane": {
    "lat": 62.808785,
    "lng": 23.513745
  },
  "kurikka": {
    "lat": 62.622079,
    "lng": 22.390229
  },
  "kustavi": {
    "lat": 60.545117,
    "lng": 21.356268
  },
  "kuusamo": {
    "lat": 65.977665,
    "lng": 29.17215
  },
  "kyyjärvi": {
    "lat": 63.044776,
    "lng": 24.558774
  },
  "kärkölä": {
    "lat": 60.87353,
    "lng": 25.272664
  },
  "kärsämäki": {
    "lat": 63.981404,
    "lng": 25.75745
  },
  "kökar": {
    "lat": 59.92107,
    "lng": 20.908501
  },
  "köyliö": {
    "lat": 61.117898,
    "lng": 22.308105
  },
  "lahti": {
    "lat": 60.982995,
    "lng": 25.65739
  },
  "laihia": {
    "lat": 62.97807,
    "lng": 22.01341
  },
  "laitila": {
    "lat": 60.874496,
    "lng": 21.696631
  },
  "lapinjärvi": {
    "lat": 60.624626,
    "lng": 26.219344
  },
  "lapinlahti": {
    "lat": 63.366375,
    "lng": 27.391945
  },
  "lappajärvi": {
    "lat": 63.225242,
    "lng": 23.629999
  },
  "lappeenranta": {
    "lat": 61.05534,
    "lng": 28.189015
  },
  "lapua": {
    "lat": 62.972328,
    "lng": 23.003516
  },
  "laukaa": {
    "lat": 62.417359,
    "lng": 25.946853
  },
  "lavia": {
    "lat": 61.596626,
    "lng": 22.586406
  },
  "lemi": {
    "lat": 61.066706,
    "lng": 27.800534
  },
  "lemland": {
    "lat": 60.069302,
    "lng": 20.09314
  },
  "lempäälä": {
    "lat": 61.315624,
    "lng": 23.752397
  },
  "leppävirta": {
    "lat": 62.489596,
    "lng": 27.76713
  },
  "lestijärvi": {
    "lat": 63.522005,
    "lng": 24.66676
  },
  "lieksa": {
    "lat": 63.314515,
    "lng": 30.030851
  },
  "lieto": {
    "lat": 60.505772,
    "lng": 22.463812
  },
  "liminka": {
    "lat": 64.80177,
    "lng": 25.43184
  },
  "liperi": {
    "lat": 62.52556,
    "lng": 29.383436
  },
  "lohja": {
    "lat": 60.2511,
    "lng": 24.069765
  },
  "loimaa": {
    "lat": 60.85407,
    "lng": 23.038995
  },
  "loppi": {
    "lat": 60.71954,
    "lng": 24.442365
  },
  "loviisa": {
    "lat": 60.456844,
    "lng": 26.223666
  },
  "luhanka": {
    "lat": 61.794222,
    "lng": 25.698467
  },
  "lumijoki": {
    "lat": 64.836995,
    "lng": 25.189025
  },
  "lumparland": {
    "lat": 60.117008,
    "lng": 20.257311
  },
  "luoto": {
    "lat": 63.70996,
    "lng": 22.760435
  },
  "luumäki": {
    "lat": 60.952165,
    "lng": 27.756825
  },
  "luvia": {
    "lat": 61.361676,
    "lng": 21.62292
  },
  "maalahti": {
    "lat": 62.94592,
    "lng": 21.560395
  },
  "maaninka": {
    "lat": 63.157704,
    "lng": 27.310409
  },
  "maarianhamina": {
    "lat": 60.114182,
    "lng": 19.93779
  },
  "marttila": {
    "lat": 60.585304,
    "lng": 22.898861
  },
  "masku": {
    "lat": 60.574737,
    "lng": 22.098343
  },
  "merijärvi": {
    "lat": 64.294595,
    "lng": 24.445745
  },
  "merikarvia": {
    "lat": 61.865629,
    "lng": 21.503468
  },
  "miehikkälä": {
    "lat": 60.671575,
    "lng": 27.700618
  },
  "mikkeli": {
    "lat": 61.68674,
    "lng": 27.271265
  },
  "muhos": {
    "lat": 64.804925,
    "lng": 26.01023
  },
  "multia": {
    "lat": 62.40972,
    "lng": 24.799535
  },
  "muonio": {
    "lat": 67.956815,
    "lng": 23.67901
  },
  "mustasaari": {
    "lat": 63.119705,
    "lng": 21.70406
  },
  "muurame": {
    "lat": 62.13533,
    "lng": 25.669128
  },
  "mynämäki": {
    "lat": 60.678033,
    "lng": 21.991107
  },
  "myrskylä": {
    "lat": 60.669951,
    "lng": 25.854529
  },
  "mäntsälä": {
    "lat": 60.62147,
    "lng": 25.305248
  },
  "mänttä-vilppula": {
    "lat": 62.03001,
    "lng": 24.62209
  },
  "mäntyharju": {
    "lat": 61.41808,
    "lng": 26.869615
  },
  "naantali": {
    "lat": 60.46513,
    "lng": 22.033525
  },
  "nakkila": {
    "lat": 61.36619,
    "lng": 22.011645
  },
  "nastola": {
    "lat": 60.936788,
    "lng": 25.947157
  },
  "nivala": {
    "lat": 63.929419,
    "lng": 24.961603
  },
  "nokia": {
    "lat": 61.480752,
    "lng": 23.504198
  },
  "nousiainen": {
    "lat": 60.59747,
    "lng": 22.085055
  },
  "nurmes": {
    "lat": 63.553481,
    "lng": 29.11571
  },
  "nurmijärvi": {
    "lat": 60.463125,
    "lng": 24.806005
  },
  "närpiö": {
    "lat": 62.477885,
    "lng": 21.33744
  },
  "orimattila": {
    "lat": 60.801865,
    "lng": 25.733415
  },
  "oripää": {
    "lat": 60.85864,
    "lng": 22.692045
  },
  "orivesi": {
    "lat": 61.68487,
    "lng": 24.358665
  },
  "oulainen": {
    "lat": 64.259667,
    "lng": 24.812921
  },
  "oulu": {
    "lat": 65.0103,
    "lng": 25.473505
  },
  "outokumpu": {
    "lat": 62.73283,
    "lng": 29.042715
  },
  "padasjoki": {
    "lat": 61.34781,
    "lng": 25.235023
  },
  "paimio": {
    "lat": 60.443621,
    "lng": 22.708334
  },
  "paltamo": {
    "lat": 64.407416,
    "lng": 27.838446
  },
  "parainen": {
    "lat": 60.305691,
    "lng": 22.29858
  },
  "parikkala": {
    "lat": 61.55702,
    "lng": 29.501105
  },
  "parkano": {
    "lat": 62.010322,
    "lng": 23.0171
  },
  "pedersören kunta": {
    "lat": 63.595305,
    "lng": 22.80812
  },
  "pelkosenniemi": {
    "lat": 67.110002,
    "lng": 27.516146
  },
  "pello": {
    "lat": 66.77385,
    "lng": 23.96518
  },
  "perho": {
    "lat": 63.213983,
    "lng": 24.420002
  },
  "pertunmaa": {
    "lat": 61.509962,
    "lng": 26.484513
  },
  "petäjävesi": {
    "lat": 62.265472,
    "lng": 25.174509
  },
  "pieksämäki": {
    "lat": 62.3037,
    "lng": 27.174275
  },
  "pielavesi": {
    "lat": 63.232952,
    "lng": 26.753837
  },
  "pietarsaari": {
    "lat": 63.676392,
    "lng": 22.710959
  },
  "pihtipudas": {
    "lat": 63.371128,
    "lng": 25.5853
  },
  "pirkkala": {
    "lat": 61.465795,
    "lng": 23.644545
  },
  "polvijärvi": {
    "lat": 62.857241,
    "lng": 29.367568
  },
  "pomarkku": {
    "lat": 61.693107,
    "lng": 22.007664
  },
  "pori": {
    "lat": 61.48596,
    "lng": 21.79537
  },
  "pornainen": {
    "lat": 60.47661,
    "lng": 25.374226
  },
  "porvoo": {
    "lat": 60.396315,
    "lng": 25.67008
  },
  "posio": {
    "lat": 66.110892,
    "lng": 28.166155
  },
  "pudasjärvi": {
    "lat": 65.370215,
    "lng": 26.991629
  },
  "pukkila": {
    "lat": 60.640601,
    "lng": 25.591799
  },
  "punkalaidun": {
    "lat": 61.111575,
    "lng": 23.107605
  },
  "puolanka": {
    "lat": 64.872728,
    "lng": 27.649692
  },
  "puumala": {
    "lat": 61.525505,
    "lng": 28.182515
  },
  "pyhtää": {
    "lat": 60.492014,
    "lng": 26.544139
  },
  "pyhäjoki": {
    "lat": 64.47197,
    "lng": 24.26695
  },
  "pyhäjärvi": {
    "lat": 63.689744,
    "lng": 25.976689
  },
  "pyhäntä": {
    "lat": 64.095275,
    "lng": 26.335255
  },
  "pyhäranta": {
    "lat": 60.949436,
    "lng": 21.445088
  },
  "pälkäne": {
    "lat": 61.33605,
    "lng": 24.270205
  },
  "pöytyä": {
    "lat": 60.7615,
    "lng": 22.639326
  },
  "raahe": {
    "lat": 64.686915,
    "lng": 24.478425
  },
  "raasepori": {
    "lat": 59.974495,
    "lng": 23.43588
  },
  "raisio": {
    "lat": 60.486745,
    "lng": 22.16776
  },
  "rantasalmi": {
    "lat": 62.069351,
    "lng": 28.301371
  },
  "ranua": {
    "lat": 65.926348,
    "lng": 26.532502
  },
  "rauma": {
    "lat": 61.131158,
    "lng": 21.51052
  },
  "rautalampi": {
    "lat": 62.62407,
    "lng": 26.82811
  },
  "rautavaara": {
    "lat": 63.495035,
    "lng": 28.29572
  },
  "rautjärvi": {
    "lat": 61.29778,
    "lng": 29.085722
  },
  "reisjärvi": {
    "lat": 63.60517,
    "lng": 24.93969
  },
  "riihimäki": {
    "lat": 60.739375,
    "lng": 24.77402
  },
  "ristijärvi": {
    "lat": 64.504467,
    "lng": 28.214936
  },
  "rovaniemi": {
    "lat": 66.503566,
    "lng": 25.72803
  },
  "ruokolahti": {
    "lat": 61.291877,
    "lng": 28.839552
  },
  "ruovesi": {
    "lat": 61.984715,
    "lng": 24.06743
  },
  "rusko": {
    "lat": 60.541445,
    "lng": 22.221875
  },
  "rääkkylä": {
    "lat": 62.310827,
    "lng": 29.621337
  },
  "saarijärvi": {
    "lat": 62.708545,
    "lng": 25.254251
  },
  "salla": {
    "lat": 66.832804,
    "lng": 28.669221
  },
  "salo": {
    "lat": 60.385868,
    "lng": 23.123019
  },
  "saltvik": {
    "lat": 60.273251,
    "lng": 20.061131
  },
  "sastamala": {
    "lat": 61.336878,
    "lng": 22.919194
  },
  "sauvo": {
    "lat": 60.343468,
    "lng": 22.69416
  },
  "savitaipale": {
    "lat": 61.19241,
    "lng": 27.68872
  },
  "savonlinna": {
    "lat": 61.86839,
    "lng": 28.86763
  },
  "savukoski": {
    "lat": 67.292067,
    "lng": 28.159309
  },
  "seinäjoki": {
    "lat": 62.790695,
    "lng": 22.83961
  },
  "sievi": {
    "lat": 63.90279,
    "lng": 24.52265
  },
  "siikainen": {
    "lat": 61.8769,
    "lng": 21.819924
  },
  "siikajoki": {
    "lat": 64.81545,
    "lng": 24.76677
  },
  "siikalatva": {
    "lat": 64.27163,
    "lng": 25.86645
  },
  "siilinjärvi": {
    "lat": 63.085685,
    "lng": 27.64824
  },
  "simo": {
    "lat": 65.662619,
    "lng": 25.064864
  },
  "sipoo": {
    "lat": 60.376721,
    "lng": 25.260191
  },
  "siuntio": {
    "lat": 60.13887,
    "lng": 24.226915
  },
  "sodankylä": {
    "lat": 67.41504,
    "lng": 26.59288
  },
  "soini": {
    "lat": 62.873469,
    "lng": 24.205324
  },
  "somero": {
    "lat": 60.633157,
    "lng": 23.516982
  },
  "sonkajärvi": {
    "lat": 63.672532,
    "lng": 27.523183
  },
  "sotkamo": {
    "lat": 64.13229,
    "lng": 28.403585
  },
  "sottunga": {
    "lat": 60.132771,
    "lng": 20.667259
  },
  "sulkava": {
    "lat": 61.78578,
    "lng": 28.363181
  },
  "sund": {
    "lat": 60.223572,
    "lng": 20.16362
  },
  "suomussalmi": {
    "lat": 64.901105,
    "lng": 29.00588
  },
  "suonenjoki": {
    "lat": 62.632818,
    "lng": 27.109937
  },
  "sysmä": {
    "lat": 61.501815,
    "lng": 25.68206
  },
  "säkylä": {
    "lat": 61.05062,
    "lng": 22.345205
  },
  "taipalsaari": {
    "lat": 61.158295,
    "lng": 28.06702
  },
  "taivalkoski": {
    "lat": 65.577905,
    "lng": 28.24417
  },
  "taivassalo": {
    "lat": 60.560767,
    "lng": 21.608999
  },
  "tammela": {
    "lat": 60.80691,
    "lng": 23.759515
  },
  "tampere": {
    "lat": 61.497815,
    "lng": 23.762265
  },
  "tarvasjoki": {
    "lat": 60.58417,
    "lng": 22.735465
  },
  "tervo": {
    "lat": 62.956725,
    "lng": 26.761735
  },
  "tervola": {
    "lat": 66.08813,
    "lng": 24.81107
  },
  "teuva": {
    "lat": 62.484847,
    "lng": 21.731505
  },
  "tohmajärvi": {
    "lat": 62.224743,
    "lng": 30.336742
  },
  "toholampi": {
    "lat": 63.773585,
    "lng": 24.24994
  },
  "toivakka": {
    "lat": 62.097295,
    "lng": 26.08123
  },
  "tornio": {
    "lat": 65.84615,
    "lng": 24.14993
  },
  "turku": {
    "lat": 60.452805,
    "lng": 22.251551
  },
  "tuusniemi": {
    "lat": 62.80344,
    "lng": 28.4994
  },
  "tuusula": {
    "lat": 60.403298,
    "lng": 25.025975
  },
  "tyrnävä": {
    "lat": 64.763503,
    "lng": 25.651559
  },
  "ulvila": {
    "lat": 61.428095,
    "lng": 21.871769
  },
  "urjala": {
    "lat": 61.078695,
    "lng": 23.529807
  },
  "utajärvi": {
    "lat": 64.740102,
    "lng": 26.457534
  },
  "utsjoki": {
    "lat": 69.907867,
    "lng": 27.026083
  },
  "uurainen": {
    "lat": 62.499668,
    "lng": 25.440316
  },
  "uusikaarlepyy": {
    "lat": 63.5226,
    "lng": 22.531275
  },
  "uusikaupunki": {
    "lat": 60.80506,
    "lng": 21.427349
  },
  "vaala": {
    "lat": 64.557848,
    "lng": 26.834128
  },
  "vaasa": {
    "lat": 63.098385,
    "lng": 21.62624
  },
  "valkeakoski": {
    "lat": 61.266222,
    "lng": 24.031582
  },
  "valtimo": {
    "lat": 63.675446,
    "lng": 28.826477
  },
  "vantaa": {
    "lat": 60.289348,
    "lng": 25.029676
  },
  "varkaus": {
    "lat": 62.313675,
    "lng": 27.88505
  },
  "vehmaa": {
    "lat": 60.686319,
    "lng": 21.716895
  },
  "vesanto": {
    "lat": 62.930615,
    "lng": 26.411057
  },
  "vesilahti": {
    "lat": 61.30993,
    "lng": 23.617832
  },
  "veteli": {
    "lat": 63.473257,
    "lng": 23.78932
  },
  "vieremä": {
    "lat": 63.742805,
    "lng": 27.002092
  },
  "vihti": {
    "lat": 60.418226,
    "lng": 24.340545
  },
  "viitasaari": {
    "lat": 63.088372,
    "lng": 25.861098
  },
  "vimpeli": {
    "lat": 63.15917,
    "lng": 23.83321
  },
  "virolahti": {
    "lat": 60.58785,
    "lng": 27.708096
  },
  "virrat": {
    "lat": 62.250793,
    "lng": 23.782074
  },
  "vårdö": {
    "lat": 60.242458,
    "lng": 20.37208
  },
  "vöyri": {
    "lat": 63.131269,
    "lng": 22.252743
  },
  "ylitornio": {
    "lat": 66.326255,
    "lng": 23.677035
  },
  "ylivieska": {
    "lat": 64.074284,
    "lng": 24.537461
  },
  "ylöjärvi": {
    "lat": 61.554755,
    "lng": 23.574351
  },
  "ypäjä": {
    "lat": 60.80466,
    "lng": 23.281096
  },
  "Ähtäri": {
    "lat": 62.559352,
    "lng": 24.085723
  },
  "Äänekoski": {
    "lat": 62.617039,
    "lng": 25.684345
  }
};
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/PostalAreaCoordinates.js
 ** module id = 1254
 ** module chunks = 0
 **/